"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccountProviderSSE = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const env_1 = require("../../../utils/env");
const selectors_1 = require("../../StorageProvider/selectors");
const slice_1 = require("../slice");
const selectors_2 = require("../../ConfigProvider/selectors");
const useAccountProviderSSE = ({ getEventSource, accountId, reconnectOptions, }) => {
    const sseRef = (0, react_1.useRef)({
        sse: null,
        isOpen: false,
    });
    const reconnectTimeoutRef = (0, react_1.useRef)(null);
    const retryCountRef = (0, react_1.useRef)(0);
    const storage = (0, react_redux_1.useSelector)(selectors_1.selectStorage);
    const sseConfiguration = (0, react_redux_1.useSelector)((state) => (0, selectors_2.selectSseConfiguration)(state, accountId));
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        let closeConnection = () => { };
        const connect = () => {
            if (!sseConfiguration || sseRef.current.isOpen) {
                return;
            }
            if (!env_1.isReactNative) {
                // web sse
                if (reconnectOptions &&
                    retryCountRef.current >= (reconnectOptions === null || reconnectOptions === void 0 ? void 0 : reconnectOptions.maxRetries)) {
                    console.error('Account Provider SSE: Max reconnect attempts.');
                    return;
                }
                const sse = getEventSource(sseConfiguration, {
                    withCredentials: true,
                });
                sse.onopen = () => {
                    retryCountRef.current = 0;
                    sseRef.current.isOpen = true;
                };
                sse.onmessage = (event) => {
                    dispatch(slice_1.accountProviderActions.setBalance(JSON.parse(event.data)));
                };
                sse.onerror = () => {
                    if (sse.readyState === EventSource.CLOSED) {
                        if (reconnectOptions) {
                            closeConnection();
                            retryCountRef.current += 1;
                            reconnectTimeoutRef.current = setTimeout(connect, reconnectOptions.reconnectTimeout);
                        }
                    }
                };
                sseRef.current.sse = sse;
                closeConnection = () => {
                    sse.close();
                    sseRef.current = { sse: null, isOpen: false };
                };
                window.addEventListener('unload', closeConnection);
            }
            else {
                // mobile application sse
                // we have to set token manually, so if there is no token, don't proceed
                if (!storage.accessToken) {
                    return;
                }
                const sse = getEventSource(sseConfiguration, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(storage.accessToken)}`,
                    },
                });
                sse.addEventListener('open', () => {
                    sseRef.current.isOpen = true;
                });
                sseRef.current.sse = sse;
                sse.addEventListener('message', (event) => {
                    if (event.data) {
                        dispatch(slice_1.accountProviderActions.setBalance(JSON.parse(event.data)));
                    }
                });
                closeConnection = () => {
                    sse.removeAllEventListeners();
                    sse.close();
                    sseRef.current = { sse: null, isOpen: false };
                };
            }
        };
        connect();
        return () => {
            if (reconnectTimeoutRef.current) {
                clearTimeout(reconnectTimeoutRef.current);
            }
            retryCountRef.current = 0;
            closeConnection();
            if (!env_1.isReactNative) {
                window.removeEventListener('unload', closeConnection);
            }
        };
    }, [
        dispatch,
        getEventSource,
        reconnectOptions,
        sseConfiguration,
        storage.accessToken,
    ]);
};
exports.useAccountProviderSSE = useAccountProviderSSE;
//# sourceMappingURL=useAccountProviderSSE.js.map